// * extend this file with new keys when needed

/**
 * Keys that should be scoped to the branch/brand based on the URL.
 */
var SCOPED_KEYS = {
  order: 'order',
  orderForm: 'orderForm',
  rememberOrderForm: 'rememberOrderForm',
  note: 'note'
};
/**
 * Keys that should be stored without any scoping (global).
 */

var UNSCOPED_KEYS = {
  auth: 'auth'
};
// Checks if the provided persistence key is scoped to the branch/brand.
export var isScopedKey = function isScopedKey(key) {
  return key in SCOPED_KEYS;
};
/**
 * Keys that we have used in production for some time in the past,
 * so it would be safer not to use them again.
 */

export var DEPRECATED_KEYS = [];